import React from 'react';

const CallItemSkeleton = () => {
    return (
        <div className="callScreenItem ct-flex ct-aiCenter ct-jcBetween ct-relative">
            <div className="callScreenItemLeft ct-flex ct-aiCenter ct-gap16 ct-flex1">
                <div className="callScreenAvatarContainer ct-flexCenter ct-relative skeleton-anim skeleton-avatar" />
                <div className="callScreenInfo ct-flex ct-fcol ct-jcCenter ct-gap6 ct-wFull">
                    <div className="skeleton-anim skeleton-name" />
                    <div className="skeleton-anim skeleton-details" />
                </div>
            </div>
            <div className="callScreenItemRight ct-flex ct-aiCenter ct-gap12">
                <div className="skeleton-anim skeleton-action" />
            </div>
        </div>
    );
};

export default CallItemSkeleton;
